import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';
import locationPin from '../assets/location.png';
import alentoursLogo from '../assets/alentours.mp4';
import magnifier from '../assets/magnifier_orange.png';
import favorites from '../assets/favorites.png';
import plus from '../assets/plus.png';
import plane from '../assets/send.png';
/* import CaretDown from '../assets/caret-down.svg'; */
import { useSharedState } from '../hooks/useSharedState';
import { DEFAULT_CITY } from '../utils/GlobalUtil';

function Header() {
  const [city] = useSharedState('city', DEFAULT_CITY);
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { pathname, hash } = useLocation();

  // Close on route change
  useEffect(() => { setOpen(false); }, [pathname, hash]);

  // Close when clicking outside
  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (!menuRef.current) return;
      if (e.target instanceof Node && !menuRef.current?.contains(e.target)) {
        setOpen(false);
      }      
    }
    if (open) document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [open]);

  return (
    <div className={styles.header} ref={menuRef}>
      <div>
        <Link to="/" className={styles.home}>
          {/* <img className={styles.logo} src={alentoursLogo} alt="Accueil" /> */}
          <video autoPlay muted playsInline width="200" height="64">
            <source src={alentoursLogo} type='video/mp4'/>
          </video>
        </Link>
      </div>

      <div className={styles.cityContainer}>
        <img src={locationPin} alt="ville" aria-hidden="true" height="30" width="30" />
        <span className={styles.city}>Ville de {city}</span>
      </div>

      {/* Burger button (hidden on desktop) */}
      <button
        className={styles.burger}
        aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}
        aria-expanded={open}
        aria-controls="header-menu"
        onClick={() => setOpen(o => !o)}
      >
        <span className={styles.burgerBar} />
        <span className={styles.burgerBar} />
        <span className={styles.burgerBar} />
      </button>

      {/* Menu (inline on desktop, dropdown on mobile) */}
      <div
        id="header-menu"
        className={`${styles.menuItems} ${open ? styles.menuOpen : ''}`}
      >

        <div className={styles.cityContainer}>
            <img src={locationPin} alt="ville" aria-hidden="true" height="30" width="30" />
            <span className={styles.city}>Ville de {city}</span>
        </div>

        <Link to="/#subscribe"><span className={styles.menuItem}><img src={plane} alt="s'abonner" width="25" height="25" /><span className={styles.menuItemLabel}>S'abonner</span></span></Link>
        <Link to="/#search"><span className={styles.menuItem}><img src={magnifier} alt="Recherche" width="25" height="25" /><span className={styles.menuItemLabel}>Recherche</span></span></Link>
        <Link to="/mes-alentours"><span className={styles.menuItem}><img src={favorites} alt="Mes alentours" width="25" height="25" /><span className={styles.menuItemLabel}>Mes alentours</span></span></Link>
        <Link className={styles.create} to="/nouveau"><span className={styles.menuItem}><img src={plus} alt="créer" width="25" height="25" /><span className={styles.menuItemLabel}>Créer</span></span></Link>
        {/* <div className={styles.languagePicker}>
          fr <img src={CaretDown} alt="" aria-hidden="true" />
        </div> */}
      </div>
    </div>
  );
}

export default Header;
